import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=1e49cc46&"
import script from "./VersionCard.vue?vue&type=script&lang=ts&"
export * from "./VersionCard.vue?vue&type=script&lang=ts&"
import style0 from "./VersionCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports